export default __webpack_public_path__ + "static/2153-ae8ac901384ce5f81d18f6dd6681cf1b.gif";